import React from 'react'
import { Card, CardBody, Button, } from 'reactstrap'

export default function ItemTimerCard({ timeRemaining, completed, expired }) {
  let minutes = '0'
  let seconds = '00'
  if (timeRemaining > -1) {
    minutes = Math.floor(timeRemaining / 60000)
    seconds = Math.ceil((timeRemaining % 60000) / 1000)
    if (seconds < 10) {
      seconds = `0${seconds}`
    }
  }

  return (
    <div className='test-timer' style={completed && {backgroundColor: '#7d7d7d'}}>{completed ? <span className="test-finished">Finished</span> : expired ? <span className="test-finished">Expired</span> : `${minutes}:${seconds}` }</div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemTimerCard.js